<template lang="html">
  <div>
    <modal :short="true">
      <template slot="modal-header">
        <div class="header-wrapper">
          <h4 class="section-heading">
            Your Payment
          </h4>
          <close-button @closeModal="closeModal"></close-button>
        </div>
      </template>
      <template slot="modal-body">
        <div>
          <div class="col-12">
            <div v-if="payment.error && !payment.success" class="error">
              <template v-if="payment.customErrorMessage">
                <span v-html="payment.customErrorMessage"></span>
              </template>
              <template v-else>
                Payment unsuccessful. <br />
                Sorry, we are unable to process your payment. Please check your
                card details or contact the payment provider.
              </template>
            </div>
            <div v-if="!payment.error && payment.success" class="success">
              Thank you for your payment. <br />
              Please check the Dashboard to view your upcoming campaign.
            </div>
          </div>
          <div class="col-12">
            <br />
            <div class="space-between">
              <div class="order-table-heading">
                ORDER SUMMARY
              </div>
              <div class="order-table-heading">
                TOTAL (incl. GST) {{ total | formatCurrency }}
              </div>
            </div>
            <div class="row" v-if="property">
              <div class="col-3 order-media-modal">
                <div class="img-wrapper" v-if="property.mainImage">
                  <div
                    class="c__card--image--container c__slider--card"
                    v-if="property.mainImage"
                  >
                    <img
                      :src="property.mainImage.url"
                      :data-src="property.mainImage.url"
                    />
                  </div>
                </div>
              </div>
              <div class="col-9">
                <div>
                  <b>{{ property.title }} - {{ _package.title }}</b>
                </div>
                <p>{{ _package.description }}</p>
                <p>
                  Campaign start date:
                  {{ startDate | formatDate('DD MMM YYYY') }}
                </p>
                <p>Short description: {{ campaign.shortDesc }}</p>
              </div>
            </div>
            <div class="row" v-else-if="campaign.type == 'agent'">
              <div class="col-3 order-media-modal">
                <div class="img-wrapper" v-if="campaign.mainImage">
                  <div
                    class="c__card--image--container c__slider--card"
                    v-if="campaign.mainImage"
                  >
                    <img :src="mainImageFullUrl" :data-src="mainImageFullUrl" />
                  </div>
                </div>
              </div>
              <div class="col-9">
                <div>
                  <b>{{ campaign.name }}</b>
                </div>
                <p></p>
                <div>
                  <div>{{ _package.title }}</div>
                  <div v-if="campaign.adTitle">
                    Ad Title: {{ campaign.adTitle }}
                  </div>
                  <div>
                    Campaign start date:
                    {{ startDate | formatDate('DD MMM YYYY') }}
                  </div>
                </div>
                <p></p>
                <p>Ad Copy: {{ campaign.shortDescription }}</p>
              </div>
            </div>
            <div class="row" v-else-if="campaign.type == 'office'">
              <div class="col-3 order-media-modal">
                <div class="img-wrapper" v-if="campaign.mainImage">
                  <div
                    class="c__card--image--container c__slider--card"
                    v-if="campaign.mainImage"
                  >
                    <img :src="mainImageFullUrl" :data-src="mainImageFullUrl" />
                  </div>
                </div>
              </div>
              <div class="col-9">
                <div>
                  <b>{{ agency.displayName }} - {{ campaign.headline }}</b>
                </div>
                <p></p>
                <div>
                  <div>{{ _package.title }}</div>
                  <div>
                    Campaign start date:
                    {{ startDate | formatDate('DD MMM YYYY') }}
                  </div>
                </div>
                <p></p>
                <div>
                  <div>Ad Copy: {{ campaign.shortDescription }}</div>
                  <div>Destination URL: {{ campaign.destinationUrl }}</div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <div class="col-12" v-if="!(payment.success && !payment.error)">
            <div class="row" v-if="campaign.paymentOption == 'credit-card'">
              <div class="col-3">Payment</div>
              <div class="col-9">
                <div
                  class="form-group "
                  v-if="cards && cards.length > 0 && !newCard"
                >
                  <div
                    v-for="(card, index) in cards"
                    v-bind:key="index"
                    class="card-container space-between"
                  >
                    <span
                      >{{ card['brand'] }} **** **** **** {{ card['last4'] }} /
                      Exp: {{ card['exp_month'] }} -
                      {{ card['exp_year'] }}</span
                    >
                  </div>
                </div>
                <div
                  class="form-group"
                  v-if="cards && cards.length > 0 && !newCard"
                >
                  <div class="space-between">
                    <div></div>
                    <div class="c__btn--container">
                      <button
                        class="btn btn-primary"
                        @click="pay"
                        type="submit"
                      >
                        pay now
                      </button>
                    </div>
                  </div>
                  <div class="space-between">
                    <div></div>
                    <p>
                      <button class="btn-link" @click="newCard = !newCard">
                        Pay with a different card
                      </button>
                    </p>
                  </div>
                </div>
                <div class="form-group " v-if="newCard || cards.length === 0">
                  <template>
                    <credit-card
                      ref="card"
                      :show-button="cards.length"
                      @payWithDefaultCard="payWithDefaultCard"
                      @validateCard="validateCard"
                    ></credit-card>
                  </template>
                </div>
              </div>
            </div>
            <div class="row" v-if="campaign.paymentOption == 'trading-terms'">
              <div class="col-12">
                <div class="form-group">
                  <div class="space-between">
                    <div></div>
                    <div class="c__btn--container">
                      <button
                        class="btn btn-primary"
                        @click="confirm"
                        type="submit"
                      >
                        confirm
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <result-message :errors="errors"></result-message>
        </div>
      </template>
    </modal>
    <app-modal-progress-bar
      v-if="loadingModalVisible"
      :progress="loadingModalProgress"
      :label="loadingModalLabel"
      :state="loadingModalState"
    ></app-modal-progress-bar>
  </div>
</template>

<script>
import {SwiperOptions} from '../../configs/Swiper';
import 'swiper/dist/css/swiper.css';

import Modal from '../../helpers/Modal';
import CloseButton from '../../helpers/CloseButton';
import ResultMessage from '../../helpers/ResultMessage';
import CreditCard from '../CreditCard/CreditCard';
import PaymentServices from '../../services/payment';
import AppModalProgressBar from '../AppComponents/Loaders/AppModalProgressBar.vue';

export default {
  name: 'ModalOrderMedia',
  props: [
    'agency',
    '_package',
    'total',
    'campaignId',
    'startDate',
    'campaign',
    'property',
    'extendCampaignId',
  ],
  components: {
    ResultMessage,
    Modal,
    CreditCard,
    CloseButton,
    AppModalProgressBar,
  },
  data() {
    return {
      swiperOption: SwiperOptions,
      newCard: false,
      cards: [],
      errors: {
        type: Object | Error,
        $clean: true,
      },
      formState: {},
      showUserModal: false,
      payment: {
        success: false,
        error: false,
        successMessage:
          'Payment successful. <br> Sorry, we are unable to process your payment. Please check your card details or contact the payment provider.',
        customErrorMessage: null,
      },
      loadingModalLabel:
        'Campaign booking in progress. Do not exit screen until complete.',
      loadingModalProgress: 0,
      loadingModalState: 'loading',
      loadingModalVisible: false,
      isOrdering: false
    };
  },
  methods: {
    payWithDefaultCard() {
      this.newCard = false;
    },
    pay() {
      event.preventDefault();
      event.target.disabled = true;
      this.cards[0].newCard = false;
      this.order(this.cards[0], null);
    },
    confirm() {
      event.preventDefault();
      event.target.disabled = true;
      this.order(null, null);
    },
    validateCard(token, target) {
      let card = {
        newCard: true,
        id: token,
      };
      this.order(card, target);
    },
    order(card, target) {
      if (this.isOrdering === true) {
        return;
      }
      this.isOrdering = true;
      this.payment.customErrorMessage = null;

      this.loadingModalLabel =
        'Campaign booking in progress. Do not exit screen until complete.';
      this.loadingModalVisible = true;
      this.loadingModalProgress = 0;
      this.loadingModalState = 'loading';

      setTimeout(() => {
        this.loadingModalProgress = 20;
      }, 250);

      setTimeout(() => {
        this.loadingModalProgress = 50;
      }, 2000);

      let interval = setInterval(() => {
        if (this.loadingModalProgress < 95) {
          this.loadingModalProgress = this.loadingModalProgress + 1;
        }
      }, 1000);

      PaymentServices.payCampaign(this.campaignId, card)
        .then((result) => {
          if (result['errors']) {
            this.payment.error = true;
            this.payment.success = false;
            this.customErrorHandler(result['errors']);
            if (target) {
              target.disabled = false;
            }
          } else {
            if (this.extendCampaignId) {
              PaymentServices.payCampaign(this.extendCampaignId, null)
                .then((result) => {
                  if (result['errors']) {
                    this.payment.error = true;
                    this.payment.success = false;
                    this.customErrorHandler(result['errors']);
                    if (target) {
                      target.disabled = false;
                    }
                  } else {
                    this.payment.error = false;
                    this.payment.success = true;
                  }
                })
                .catch((errors) => {
                  if (
                    errors.length > 0 &&
                    '$error' in errors[0] &&
                    errors[0]['$error'].length > 0 &&
                    'message' in errors[0]['$error'][0]
                  ) {
                    this.customErrorHandler(errors[0]['$error'][0].message);
                  }
                  this.payment.error = true;
                  if (target) {
                    target.disabled = false;
                  }
                });
            } else {
              this.payment.error = false;
              this.payment.success = true;
              this.loadingModalLabel = "Campaign booked successfully."
            }
          }
        })
        .catch((errors) => {
          if (
            errors.length > 0 &&
            '$error' in errors[0] &&
            errors[0]['$error'].length > 0 &&
            'message' in errors[0]['$error'][0]
          ) {
            this.customErrorHandler(errors[0]['$error'][0].message);
          }
          this.payment.error = true;
          if (target) {
            target.disabled = false;
          }
          this.loadingModalState = 'error';
        })
        .finally(() => {
            this.loadingModalProgress = 100;
            clearInterval(interval);
          setTimeout(() => {
            this.loadingModalVisible = false;
          }, 2000);
        });
    },
    getCards() {
      PaymentServices.getAvailableCards(this.agency.id).then((cards) => {
        if (cards) {
          this.cards = cards;
        }
      });
    },
    closeModal() {
      if (this.payment.success) {
        this.$emit('closeModalAndCleanCampaign');
      } else {
        this.$emit('closeModal');
      }
    },
    customErrorHandler(errorMessage) {
      if (errorMessage && errorMessage == 'Your card has insufficient funds.') {
        this.payment.customErrorMessage =
          'Your credit card has insufficient funds, please try again later.';
        this.loadingModalLabel =
          'Your credit card has insufficient funds, please try again later.';
      } else if (errorMessage && errorMessage == 'Your card has expired.') {
        this.payment.customErrorMessage =
          'Your credit card is expired, please update your card';
        this.loadingModalLabel =
          'Your credit card is expired, please update your card';
      } else if (
        errorMessage &&
        errorMessage == 'Signifi product could not be placed'
      ) {
        this.payment.customErrorMessage =
          'We found an issue with the campaign package you are trying to book, please contact support';
        this.loadingModalLabel =
          'We found an issue with the campaign package you are trying to book, please contact support';
      } else {
        this.payment.customErrorMessage = null;
      }
    },
  },
  created() {},
  mounted() {
    this.getCards();
  },
  computed: {
    mainImageFullUrl() {
      if (this.campaign.mainImage.location.substring(0, 4) === 'http') {
        return this.campaign.mainImage.location;
      }
      return `${process.env.VUE_APP_CDN_URL}${
        this.campaign.mainImage.location
      }`;
    },
  },
};
</script>
